export default __webpack_public_path__ + "static/Computer-d3fc0f6efd085e1a41755b0906a09f6e.webp";